var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lv-base-column',_vm._b({ref:"column",attrs:{"externalData":{option: _vm.option,showKey: _vm.showKey,map: _vm.map}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var rowIndex = ref.rowIndex;
var col = ref.col;
var colIndex = ref.colIndex;
var editRow = ref.editRow;
var fixedRow = ref.fixedRow;
return [_c('link-table-column-object-item',_vm._b({attrs:{"row":row,"edit-row":editRow,"row-index":rowIndex,"col":col,"col-index":colIndex,"fixed-row":fixedRow,"option":_vm.option,"show-key":_vm.showKey,"map":_vm.map,"beforeSelect":_vm.beforeSelect,"afterSelect":_vm.afterSelect},on:{"click":_vm.lv_clickItem}},'link-table-column-object-item',_vm.columnItemBinding,false))]}}])},'lv-base-column',_vm.columnBinding,false))}
var staticRenderFns = []

export { render, staticRenderFns }